import React from "react";
import SelectorPopup from "../../components/SelectorPopup/SelectorPopup";
import {getCustomerType} from "../../utils/utils";


const AccountAddPopup = (props) => {
  const options = getCustomerType() === 'agency' ?  [
    {
      id: 'agency',
      title: "Neues Website-Projekt anlegen",
      text: 'Erstelle kostenlos eine neue Website mit allen Funktionen, um ein Kundenprojekt umzusetzen. Wenn du damit online gehen willst, bestelle eine oder mehrere Domains und wähle das benötigte Paket aus.'
    }
  ] : getCustomerType() === 'lock' ?  [
      {
        id: 'free',
        title: 'Kostenlose Webseite',
        text: <>Erstelle eine neue kostenlose page4 free Website. Du kannst max. 2 kostenlose Webseiten haben.</>
      }]
    :[
    {
      id: 'free',
      title: 'Kostenlose Webseite',
      text: <>Erstelle eine neue kostenlose page4 free Website. Du kannst max. 2 kostenlose Webseiten haben.</>
    },
    {
      id: 'retail',
      title: 'Kostenpflichtige Webseite',
      text: 'Erstelle eine neue Website direkt über unser Bestellformular. Wir haben drei Pakete zur Auswahl.'
    }
  ]

  return <SelectorPopup
    title={'Neue Webseite anlegen'}
    confirmButton={'Anlegen'}
    onConfirm={props.onConfirm}
    onCancel={props.onCancel}
    default={ getCustomerType() === 'agency' ? 'agency' : 'free'}
    options={options}
  />
}

export default AccountAddPopup;